<template>
  <b-card>
    <templates-list
      :carregar="carregar"
      :novo="novo"
      :editar="editar"
      :remover="remover"
      :colunas="colunasListagem"
      :info="info"
      :permissao-delete-props="false"
      :permissao-imprimir="true"
      :filtros="filtros"
      class="lista-templates"
    >
      <template
        slot="celula-personalizada"
        slot-scope="{props}"
      >
        <span v-if="props.column.field === 'tipoProposta'">
          {{ props.row.tipoProposta == 'transferencia'? 'Proposta honorários empresas em transferência' : props.row.tipoProposta == 'constituicao' ? 'Proposta honorários empresas em constituição' : props.row.tipoProposta == 'constituicaotransferencia' ? 'Proposta honorários empresas em constituição & transferência' : '' }}
        </span>
      </template>
    </templates-list>
  </b-card>
</template>

<style lang="scss">
.lista-templates {
  .th-acao {
    width: 10.5rem !important;
  }
}
</style>

<script>
import api from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplate/services/api'

export default {
  name: 'TemplateVisualizacao',
  components: {
    templatesList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
  },
  data() {
    return {
      colunasListagem: [
        {
          label: 'Descrição',
          field: 'descricao',
          editable: true,
        },
        {
          label: 'Tipo de proposta',
          field: 'tipoProposta',
          type: 'personalizada',
        },
      ],
      filtros: [{ colunas: ['TipoProposta', 'Descricao'], valor: null }],
      info: [
        { label: 'Data de cadastro: ', campo: 'dataCadastro' },
        { label: 'Cadastrado por: ', campo: 'usuCadastro' },
        { label: 'Data de alteração: ', campo: 'dataAlteracao' },
        { label: 'Alterado por: ', campo: 'usuAlteracao' },
      ],
    }
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    }
  },
  methods: {
    carregar(page, pageSize, filtros) {
      return api.getTemplates(page, pageSize, filtros)
    },
    novo() {
      this.$router.push({ name: 'novo-template' })
    },
    editar(value) {
      this.$router.push({ name: 'editar-template', params: { id: value.id } })
    },
    remover(itens) {
      const itensInner = itens
      return new Promise((resolve, reject) => {
      // eslint-disable-next-line no-plusplus
        for (let i = 0; i < itensInner.length; i++) {
          const item = itensInner[i]
          api.deleteTemplate(item.id)
            .then(() => {
              resolve()
            })
            .catch(err => {
              if (err.response.data.message.includes('error occurred while updating the entries')) {
                this.$erro('Não é permitido realizar a exclusão deste template, pois existe vínculo com as propostas.')
              } else {
                reject(err)
              }
            })
        }
      })
    },
  },
}
</script>
